/**
 * Species offered when creating an animal. The key is what the Scribe API
 * accepts (it maps keys to the labels manta stores); labels live in the
 * `workspace.species.*` locale entries.
 */
export const SPECIES_KEYS = [
  'dog',
  'cat',
  'rabbit',
  'guinea_pig',
  'ferret',
  'horse',
  'bird',
  'turtle',
  'snake',
  'lizard',
  'fish',
  'livestock',
  'other',
] as const;

export type SpeciesKey = (typeof SPECIES_KEYS)[number];

/** The labels manta stores for each key; must match the Scribe backend. */
const STORED_LABELS: Record<SpeciesKey, string> = {
  dog: 'Hund',
  cat: 'Katze',
  rabbit: 'Kaninchen',
  guinea_pig: 'Meerschweinchen',
  ferret: 'Frettchen',
  horse: 'Pferd',
  bird: 'Ziervogel',
  turtle: 'Schildkröte',
  snake: 'Schlange',
  lizard: 'Echse',
  fish: 'Fisch',
  livestock: 'Rind',
  other: 'Sonstige',
};

export function isSpeciesKey(value: unknown): value is SpeciesKey {
  return SPECIES_KEYS.some((key) => key === value);
}

/** Maps a species as stored in manta back to its key, if it is one of ours. */
export function speciesKeyOf(
  stored: string | null | undefined,
): SpeciesKey | undefined {
  const normalized = stored?.trim().toLowerCase();
  if (!normalized) return undefined;
  return SPECIES_KEYS.find(
    (key) => STORED_LABELS[key].toLowerCase() === normalized,
  );
}
